import { createReducer } from "../../common/reduxUtil";
import {
  UPDATE_CURRENT_EXCHANGE_RATE,
  UPDATE_USER_LOCATION,
  UPDATE_USER_STATE_LOCATION,
} from "./types";

const initialState = {
  location: "",
  currentStateLocation: {},
  currentExchangeRate: 1,
};

export default createReducer(initialState, {
  [UPDATE_USER_LOCATION]: (state, payload) => {
    return Object.assign({}, state, {
      ...state,
      location: payload,
    });
  },
  [UPDATE_USER_STATE_LOCATION]: (state, payload) => {
    return Object.assign({}, state, {
      ...state,
      currentStateLocation: payload,
    });
  },
  [UPDATE_CURRENT_EXCHANGE_RATE]: (state, payload) => {
    return Object.assign({}, state, {
      ...state,
      currentExchangeRate: payload,
    });
  },
});
